import React, { useState } from "react";
import { t } from "i18next";
import WalletTopUp from "./WalletTopUp";
import PaymentHistory from "./PaymentHistory";
import BuyPackage from "./BuyPackage";
import Accounting from "./Accounting";
import Icon from "../../../common/components/Icon";

const TABS = [
    { id: "walletTopUp", labelKey: "replenishWallet", icon: "wallet" },
    { id: "paymentHistory", labelKey: "paymentHistory", icon: "history" },
    { id: "purchasePackage", labelKey: "buyPackage", icon: "flash" },
    { id: "accounting", labelKey: "accounting", icon: "file" },
];

function Finance({ setActiveTab }) {
    const [activeSubTab, setActiveSubTab] = useState("walletTopUp");

    return (
        <div className="w-full">
            <button
                onClick={() => setActiveTab(null)}
                className="md:hidden flex items-center gap-2 text-gray-500 text-sm mb-4"
            >
                <Icon src="backicon" className="w-5 h-5" />
            </button>

            <div className="bg-white rounded-2xl overflow-hidden">
                {/* Sub-tab navigation */}
                <div className="border-b border-gray-100 px-4">
                    <div className="flex gap-1 py-3 overflow-x-auto scrollbar-none" style={{ scrollbarWidth: "none" }}>
                        {TABS.map((tab) => (
                            <button
                                key={tab.id}
                                onClick={() => setActiveSubTab(tab.id)}
                                className={`flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-medium transition-colors whitespace-nowrap
                                    ${activeSubTab === tab.id
                                        ? "bg-[#147F26] text-white"
                                        : "text-gray-500 hover:text-gray-700 hover:bg-gray-100"
                                    }`}
                            >
                                <Icon
                                    src={tab.icon}
                                    className={`w-4 h-4 ${activeSubTab === tab.id ? "brightness-0 invert" : ""}`}
                                />
                                {t(tab.labelKey)}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Sub-tab content */}
                <div>
                    {activeSubTab === "walletTopUp" && <WalletTopUp setActiveTab={setActiveTab} embedded />}
                    {activeSubTab === "paymentHistory" && <PaymentHistory setActiveTab={setActiveTab} embedded />}
                    {activeSubTab === "purchasePackage" && <BuyPackage setActiveTab={setActiveTab} embedded />}
                    {activeSubTab === "accounting" && <Accounting setActiveTab={setActiveTab} />}
                </div>
            </div>
        </div>
    );
}

export default Finance;
